import { useEffect, useState, useRef } from 'react'
import { Table, Tooltip } from 'antd'
import type { ColumnsType } from 'antd/es/table';
import style from './index.module.scss'
import * as apis from '../../api/networkDisk'

import user_default from '../../static/image/user_default.png'
import { getImgUrlById, deepCopy } from '../../util'
import useStore from '../../store/useStore'
import { memosModule } from '../../modules/memos'
import ManList from '../../components/talk/manList'

interface Props {
    // visible: any
    onClose: () => void;
    // onRefresh: () => void;
    // title: any;
}
interface DataType {
    key: React.Key;
    name: string;
}

const JionThemes = (props: Props) => {
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [disabled, setDisabled] = useState<boolean>(true);
    const [data, setData] = useState<any>();
    const { store, dispatch } = useStore();

    const columns: ColumnsType<DataType> = [
        {
            title: '主题',
            dataIndex: 'subject',
            key: 'subject',

            colSpan: 1,
            render: (text: string, record: any) => <span >
                {text}
            </span>,
        },
        {
            title: '参与讨论人',
            align: 'left',
            key: 'userInfos',
            dataIndex: 'userInfos',
            width: '270px',
            colSpan: 1,
            render: (users: any, record) => <span>
                <div data-flex='main:left'>
                    <ManList isShowName={false} limit={5} data={record} showRemove={false} onRefresh={() => {
                        setTimeout(() => {
                            getList()
                        }, 1000);
                    }} />
                    {users?.length > 5 && <Tooltip trigger={['click']} color={'#fff'} placement="bottomRight" title={<div data-flex='main:left'>
                        <div className='toop-user'><ManList showNoExit={true} showRemove={false} isShowName={false} excludeLimit={5} isWap={true} data={record} /></div>
                    </div>}
                        overlayInnerStyle={{ color: "#171A1E" }}
                        overlayStyle={{ maxWidth: "50%" }}
                    >
                        <div className={style.userInfos_item}>+<br />{users?.length - 5}</div>
                    </Tooltip>
                    }
                    {/* {

                        users && users.map((i: any, index: any) => (
                            <Tooltip title={i.username} key={index}>
                                <img alt="" className={style.user_default + ' mr-10 mb-5 mt-5'} src={(i.avatar) ? getImgUrlById(i.avatar) : user_default} onError={(e: any) => { e.target.onerror = null; e.target.src = user_default }} />
                            </Tooltip>
                        ))
                    } */}
                </div>
            </span>,
        },
    ];
    //删除当前监听
    const onDeleteListener = async (id: any) => {
        try {
            let res: any = await apis.deleteListener(id)
        } catch (e) { }
    }
    const goMemos = (record: any) => {
        if (record.id !== store.subjectInfo.subjectId) {
            onDeleteListener(store.subjectInfo.subjectId)
            getDetail(record.id)
            // dispatch({
            //     type: 'SET_SUBJECTINFO',
            //     data: { subjectCatalogue: [], subjectId: record.id, data: store.subjectInfo.initData }
            // });
        }
        // window.location.hash = '#/view'

    }
    const getDetail = async (id: any, node?: any) => {
        try {
            await memosModule.getDetail(id).then((res) => {
                console.log('res', res)
                if (res.ok) {
                    let subjectInfo = {
                        subjectId: res.data.id,
                        subjectTitle: res.data.subject,
                        subjectCatalogue: res.data.catalogue,
                        total: res.data.memos.length,
                        data: res.data,
                        catalogueId: res.data.catalogueInfo,
                        permissions: res.data.permissions,
                    };

                    dispatch({
                        type: 'SET_SUBJECTINFO',
                        data: { subjectCatalogue: [], subjectId: id, data: subjectInfo }
                    });

                }
            }).catch((e) => {
                //console.log(e)
            })
            props.onClose()
        } catch (e: any) {
            //console.log(e.code)
            props.onClose()
        }
    }
    useEffect(() => {
        getList()
    }, [])

    const getList = async () => {
        try {
            let res: any = await apis.excellingTopic({
                hasUsers: true
            })
            if (res.ok) {
                setData(res.data)
                console.log('setData')
            }
        } catch (e) { }
    }
    const rowSelection = {
        selectedRowKeys,
        onChange: (selectedRowKeys: React.Key[], selectedRows: DataType[],) => {
            console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
            // console.log(`onSelectNone:${onSelectNone}`)
            setSelectedRowKeys(selectedRowKeys)
            selectedRowKeys?.length > 0 ? setDisabled(false) : setDisabled(true)

        },

        // getCheckboxProps: (record: DataType) => ({
        //     disabled: record.name === 'Disabled User', // Column configuration not to be checked
        //     name: record.name,
        // }),
    };

    return (
        <div >
            <Table
                // rowSelection={{
                //      type: 'checkbox',
                //     ...rowSelection,
                // }}
                onRow={record => {
                    return {
                        onDoubleClick: event => {
                            console.log('点击行')
                            goMemos(record)
                        }, // 点击行
                    }
                }}
                // key={new Date().getTime()}
                scroll={{ y: '45vh' }}
                rowKey="id"
                pagination={false}
                columns={columns}
                dataSource={data}
            /></div>
    )
}

export default JionThemes